import {
  string as yupString,
} from 'yup';

import InputFormik from '../../shared/forms/input/inputFormik.component';
import SelectFormik from '../../shared/forms/select/sdkSelectFormik.component';
import { required, maxLength, nullable } from '../../shared/forms/validators';

const schema = [
  {
    name: 'taxDescription',
    component: SelectFormik,
    meta: { label: 'Tax Description', optionsKey: 'taxDescriptionNamesOptions' },
    options: { disabledWhenEditing: true, yupType: yupString(), validationRules: [required] },
    additionalProps: { required: true },
  },
  {
    name: 'enabledFlag',
    component: SelectFormik,
    meta: { label: 'Enabled Flag', optionsKey: 'enabledFlagOptions' },
    options: { yupType: yupString(), validationRules: [required] },
    additionalProps: { required: true },
  },
  {
    name: 'plAccount',
    component: SelectFormik,
    meta: { label: 'P&L', optionsKey: 'plAccountOptions' },
    options: { yupType: yupString(), validationRules: [nullable] },
    additionalProps: { clearable: true, virtualized: true },
  },
  {
    name: 'bsAccount',
    component: SelectFormik,
    meta: { label: 'Balance Sheet', optionsKey: 'bsAccountOptions' },
    options: { yupType: yupString(), validationRules: [nullable] },
    additionalProps: { clearable: true, virtualized: true },
  },
  {
    name: 'reclassPlAccount',
    component: SelectFormik,
    meta: { label: 'Reclass P&L', optionsKey: 'reclassPlAccountOptions' },
    options: { yupType: yupString(), validationRules: [nullable] },
    additionalProps: { clearable: true, virtualized: true },
  },
  {
    name: 'reclassBsAccount',
    component: SelectFormik,
    meta: { label: 'Reclass Balance Sheet', optionsKey: 'reclassBsAccountOptions' },
    options: { yupType: yupString(), validationRules: [nullable] },
    additionalProps: { clearable: true, virtualized: true },
  },
  {
    name: 'goldId',
    component: InputFormik,
    meta: { label: 'GOLD ID' },
    options: { yupType: yupString(), validationRules: [maxLength(6)] },
  },
];

export default schema;
